import * as z from "zod/v4";

export const disconnectStripeIntegration = {
  name: "disconnectStripeIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
